import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Reveals the error message only once the control has been visited, unlike
 * `CustomErrorStateMatcher` which also reveals it as soon as a value is present.
 * The control still reports its errors to the form, so error counting and
 * "go to next error" navigation see it before the user ever reaches the field.
 */
export class TouchedErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    return !!control?.touched && control.invalid;
  }
}
